import { useMemo } from 'react';
import { useLang } from 'hooks/lang';

import { loaders } from 'entities';

import { Row, LabeledSelect, Tag } from 'components/Blocks';
import { UserAvatar } from 'components/UserAvatar';

import { useProjectProfile } from 'pages/Projects/ProjectProfile/context';
import { useUser } from 'hooks/user';

import { sortByName, toUniqueList } from 'utils/array';
import { DEFAULT_NO_OWNER_USER } from 'utils/constants';

import { StateProps } from './types';

export function Executors({ dispatch, state }: StateProps) {
  const { t } = useLang();
  const user = useUser();

  const { projectUsers } = useProjectProfile();

  const { data: leaders, loading } = loaders.users.leaders.use({
    defaultValue: [],

    blockLoad: !open,

    params: {
      teams: toUniqueList(Object.values(projectUsers).map(({ team }) => team)),
    },
  });

  const executors = useMemo(() => {
    const projectPresence = Object.values(projectUsers).filter(
      ({ id }) => !leaders.find((user) => user.id === id),
    );

    return sortByName(
      [...projectPresence, ...leaders].filter(
        ({ id }) =>
          [user.id, DEFAULT_NO_OWNER_USER.id].every((badId) => badId !== id) &&
          !state.sales.includes(id),
      ),
    );
  }, [projectUsers, user, state.sales, leaders]);

  return (
    <LabeledSelect
      label={t('executors')}
      isMulti
      onChangeDirect={(executors) => dispatch({ executors })}
      value={state.executors}
      labelKey="name"
      options={executors}
      loading={loading}
      hideSelectedOptions
      formatLabel={(user) => (
        <Row gap="1">
          <UserAvatar user={user} size={20} className="text-xs" name nameGap="1.5" />

          {user.type === 'LEADER' && (
            <Tag size="tiny" name={t('leader')} color="primary-light" round={false} />
          )}
        </Row>
      )}
    />
  );
}
